import {createContext, useContext} from "react";

export const PasswordModalContext = createContext(null);
export const usePasswordModalContext = () => useContext(PasswordModalContext)